import api from '@/services/utils/apiInstance.ts'

import { TrackRecordSourceEnum } from '@/enums/trackRecord_enum.ts'
import type {
  TrackRecordAnalyzeResponse,
  TrackRecordImportResponse,
  TrackRecordPerfType,
  TrackRecordPerfUnit,
} from '@/types/services/mandate/trackRecord.type.ts'

export interface TrackRecordImportParams {
  file: File
  date_column: string
  source: TrackRecordSourceEnum
  mode: 'value' | 'perf'
  value_column?: string
  perf_column?: string
  perf_type?: TrackRecordPerfType
  perf_unit?: TrackRecordPerfUnit | null
  capital_initial?: number
  replace_existing?: boolean
}

class TrackRecordService {
  async analyze(mandateId: number, file: File): Promise<TrackRecordAnalyzeResponse> {
    const fd = new FormData()
    fd.append('file', file)

    const response = await api.post(`/track-record/${mandateId}/analyze`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })

    return response.data as TrackRecordAnalyzeResponse
  }

  async import(mandateId: number, params: TrackRecordImportParams): Promise<TrackRecordImportResponse> {
    const fd = new FormData()
    fd.append('file', params.file)
    fd.append('date_column', params.date_column)
    fd.append('source', params.source)

    if (params.mode === 'value') {
      fd.append('value_column', params.value_column!)
    } else {
      fd.append('perf_column', params.perf_column!)
      fd.append('perf_type', params.perf_type!)
      if (params.perf_unit) {
        fd.append('perf_unit', params.perf_unit)
      }
      fd.append('capital_initial', String(params.capital_initial ?? 100))
    }

    if (params.replace_existing) {
      fd.append('replace_existing', 'true')
    }

    const response = await api.post(`/track-record/${mandateId}/import`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })

    return response.data as TrackRecordImportResponse
  }
}

export default new TrackRecordService()
